/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.modals.cancel.controllers', [
  'ui.bootstrap'
])

.controller('PassesCreateModalsCancelController', ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

    $scope.passesCreateModalsCancel = {

      model: "Your spankin new application.passes.create.modals.cancel view!",

      init: function() {},

      confirm: function () {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.passesCreateModalsCancel.init();

}]);